import React from 'react';
import ReactDOM from 'react-dom/client';
import './MainPage.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ============================================
// SERVICE WORKER - COMPLETELY DECOUPLED
// NO INTERNAL STATE TRACKING - WORKS DIRECTLY
// ============================================
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    // SIMPLE: Just register and handle updates directly
    let updateAvailable = false;
    let isReloading = false;

    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((registration) => {
        console.log("✅ Service Worker registered");

        // SIMPLE: Check for updates every hour
        registration.update();
        setInterval(() => {
          if (!isReloading) {
            registration.update();
            console.log("🔍 Checking for updates...");
          }
        }, 3600000);

        // SIMPLE: Handle update found
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener("statechange", () => {
            // DIRECT: When new worker is installed and waiting
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              // DIRECT: Show prompt only if not already updating
              if (!updateAvailable && !isReloading) {
                updateAvailable = true;
                
                console.log("🆕 New version available!");
                
                // DIRECT: Ask user
                if (window.confirm("A new version is available! Click OK to update.")) {
                  isReloading = true;
                  // DIRECT: Tell SW to activate
                  newWorker.postMessage("SKIP_WAITING");
                } else {
                  // User said no, allow checking again later
                  setTimeout(() => {
                    updateAvailable = false;
                  }, 60000);
                }
              }
            }
          });
        });
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });

    // DIRECT: Handle SW activation
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!isReloading) {
        isReloading = true;
        console.log("🔄 Updating...");
        window.location.reload();
      }
    });
  });
}

// Report web vitals
reportWebVitals(console.log);